import Cookies from 'js-cookie';
import { logEvent, setUserProperties } from 'firebase/analytics';
import { analytics } from '../firebase'; 

const userActivity = [];
const uid = Cookies.get('userid');

// Set user properties at the start
if (uid) {
    setUserProperties(analytics, { user: uid });
} else {
    setUserProperties(analytics, { user: 'NOT LOGIN' });
}

document.addEventListener('click', (event) => {
    const target = event.target;

    const interactionData = {
        page: window.location.pathname,
        interaction: {
            user: uid || 'NOT LOGIN',
            type: 'click',
            element: target.tagName.toLowerCase(),
            id: target.id || null,
            class: target.className || null,
            timestamp: new Date().toISOString(),
        },
    };
    userActivity.push(interactionData);
    sendActivityData(event, interactionData);

});

export const logAnalyticsEvent = async (eventType, data) => {
    const eventData = {
        page: window.location.pathname,
        interaction: {
            user: uid || 'NOT LOGIN',
            type: eventType,
            details: data,
            timestamp: new Date().toISOString(),
        },
        videoname: data.videoname  || null,
    };
    userActivity.push(eventData);

    sendActivityData(eventType, data);
};

window.addEventListener('beforeunload', () => {
    const navigationData = {
        page: window.location.pathname,
        interaction: {
            user: uid || 'NOT LOGIN',
            type: 'navigation',
            page: window.location.pathname,
            timestamp: new Date().toISOString(),
        },
    };
    userActivity.push(navigationData);
    sendActivityData('navigation', navigationData);
});

function sendActivityData(eventType, data) {
    const activityData = JSON.stringify(userActivity);
    // console.log(activityData);

    const eventData = {
        ...data,
        timestamp: new Date().toISOString(),
        debug_mode : true
    };

    logEvent(analytics, eventType, eventData);
    // console.log('Logged to Firebase Analytics:', eventType, eventData);

}

window.addEventListener('click', (event) => {
    sendActivityData('click', { target: event.target });
});